module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "textSection"
  }, [_c('h1', [_vm._v("Crédit")]), _vm._v(" "), _c('h2', [_vm._v("Propriétaire")]), _vm._v(" "), _c('p', [_vm._v("Association Campus Urbain Seine-Amont – Association - Siret : 53527211600018 – 11-13, rue Pierre Rigaud - Ivry-sur-Seine")]), _vm._v(" "), _c('h2', [_vm._v("Créateurs")]), _vm._v(" "), _c('p', [_vm._v("Quentin VanButsele et Thomas Kerbrat")]), _vm._v(" "), _c('h2', [_vm._v("Hébergeur")]), _vm._v(" "), _c('p', [_vm._v("bookmyname.com – 75008")]), _vm._v(" "), _c('h2', [_vm._v("Crédits")]), _vm._v(" "), _c('p', [_vm._v("Association FuturÂge - Pôle Charles Foix")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-af33d01c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Credits.vue
// module id = 456
// module chunks = 1